import SignInForm, {
  Fields,
  FieldsProps as FieldsPropsType,
  Submit,
  Errors,
} from './SignInForm'

export type FieldsProps = FieldsPropsType

export default Object.assign(SignInForm, {
  Fields,
  Submit,
  Errors,
})
